import Vue from "vue";
import store from "../store/index";
import html2pdf from "html2pdf.js";

Vue.mixin({
  store: store,
  data: () => {
    return {};
  },
  methods: {
    isInUserPermissions(requiredPermissions) {},
    convertDateToArabic(dateString) {
      const date = new Date(dateString);
      const daysOfWeek = [
        "الأحد",
        "الإثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت",
      ];
      const months = [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليـو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر",
      ];

      const dayName = daysOfWeek[date.getDay()]; // in end calender week starts  with sunday
      const day = date.getDate();
      const monthName = months[date.getMonth()];
      const year = date.getFullYear();

      return `يوم ${dayName} ${day} ${monthName} ${year}`;
    },
    scaleItemClass(score) {
      if (score <= 20) return "fail";
      if (score <= 40) return "very-weak";
      if (score <= 60) return "weak";
      if (score <= 70) return "good";
      if (score <= 80) return "very-good";
      return "excellent";
    },
    handlePrint(elementId) {
      const element = document.getElementById(elementId);

      // Hide print button before generating PDF
      const printButtons = element.querySelectorAll('.print-action-button');
      printButtons.forEach(btn => btn.style.display = 'none');

      const opt = {
        margin: [5, 5, 5, 5],
        filename: "certificate.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          letterRendering: true,
          scrollY: 0,
          scrollX: 0,
          windowWidth: element.scrollWidth,
          windowHeight: element.scrollHeight,
          logging: false
        },
        jsPDF: { unit: 'mm', format: 'ledger', orientation: "portrait" },
        pagebreak: {
          mode: ["css", "legacy"],
          avoid: ['.header', '.details-section', '.general-evaluation', '.general-analysis', '.footer']
        },
      };

      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          pdf.autoPrint();
          const pdfData = pdf.output("bloburl");
          const newWindow = window.open(pdfData, "_blank");

          if (!newWindow) {
            console.error("Failed to open new window for printing!");
            return;
          }
          newWindow.onload = function () {
            newWindow.print();
            newWindow.onafterprint = function () {
              newWindow.close();
            };
          };
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
        })
        .finally(() => {
          // Show print button again after PDF generation
          const printButtons = element.querySelectorAll('.print-action-button');
          printButtons.forEach(btn => btn.style.display = '');
        });
    },
  },
});
